import { Modal } from '@kathondvla/react-shared-components/src/components';
import type { ZillGoal, ZillGoalSubDetail } from '@newStore/zill/zillTypes';
import AsideEditor from '@UI/editor/AsideEditor';
import type React from 'react';
import { useState } from 'react';

export interface ZillIllustrationModalProps {
  onClose?: () => void;
  onSubmit?: (illustrationText: string) => void;
  goal?: ZillGoal;
  subDetail?: ZillGoalSubDetail[];
}

const ZillIllustrationModal: React.FC<ZillIllustrationModalProps> = ({
  onClose = () => {},
  onSubmit,
  goal,
  subDetail,
}) => {
  const [illustrationText, setIllustrationText] = useState<string>('');

  const handleChange = (value) => {
    setIllustrationText(value);
  };

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit(illustrationText);
      onClose();
    }
  };

  return (
    <div className="overflown-modal">
      <Modal.Header title="Selecteer ZILL versie" onClose={onClose} />
      <Modal.Body>
        <div style={{ color: goal?.color }}>
          <strong>{goal?.code}</strong>:<strong>{goal?.title}</strong>
          {subDetail?.map((subDetail) => (
            <span key={subDetail.href}>
              <br />
              <span style={{ marginLeft: '10px' }} title={subDetail.description}>
                -&gt; {subDetail.shortDescription}
              </span>
            </span>
          ))}
        </div>
        <div className="form-group">
          <div className="row">
            <div className="col-md-12">
              <label>Illustratie: </label>
              <AsideEditor
                field="title"
                plainText={false}
                inline={false}
                showCharacterCount={true}
                onTextChange={handleChange}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-link pull-left" onClick={onClose}>
          Annuleren
        </button>
        <button className="btn btn-primary" onClick={handleSubmit}>
          Ok
        </button>
      </Modal.Footer>
    </div>
  );
};

ZillIllustrationModal.displayName = 'ZillIllustrationModal';

export default ZillIllustrationModal;
